/**
 * Font Size Hook
 * Applies font size from UIPreferences context (GET /users/me/ui-preferences).
 * Does not call platform font-sizes/current when authenticated.
 */

import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useUIPreferences } from '@/contexts/UIPreferencesContext'
import { applyFontSize, clearFontSize } from '@/utils/font-size-application.util'
import { isPublicRoute } from '@/utils/route.util'

/**
 * Applies current user font size from UI preferences context when available
 */
export function useFontSize() {
  const { uiPreferences } = useUIPreferences()
  const location = useLocation()
  const onPublicRoute = isPublicRoute(location.pathname)

  useEffect(() => {
    if (onPublicRoute) {
      clearFontSize()
      return
    }
    if (uiPreferences?.fontSize?.fontSize) {
      applyFontSize(uiPreferences.fontSize.fontSize as string)
    } else {
      clearFontSize()
    }
  }, [onPublicRoute, uiPreferences?.fontSize])

  return {
    currentFontSize: uiPreferences?.fontSize ?? null,
    isLoading: false,
    error: null,
  }
}

